export const CONTACT_FORM = '/form';
export const SIGN_IN = '/signin';
export const LANDING = '/';
export const PASSWORD_FORGET = '/pw-forget';

export const HOME = '/home';
export const FILE_BROWSER = '/projects';
export const SETTINGS = '/settings';
export const NEW_REGISTRATION = '/new-registration';
